import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Review/Point.html'
})

export class PointComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public points: any[] = [];
    public pointType: any[] = [];
    public reviewUsers: any[] = [];
    public addPointsData: any = { addPointsUserId: "", addPointsTypeId: "" };
    public editPointsData: any = { editPointsUserId:"", editPointsTypeId: "" };
    public isAdd: boolean = true;
    active = true;
    siteUserItems: any = [];
    public showLoader = false;
    public existsUserName: boolean = false;
    public isFormSubmitted: boolean = false;
    filter: any = {};

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.filter = { 'Year': moment().format('YYYY')};
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
        this.getUsers(true);
        this.getPointType();
        this.getPoints();
    }

    ngAfterViewInit() {

        $(".date").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $(".dateYear").datetimepicker({
            format: 'YYYY',
            maxDate:moment().set({hour:0,minute:0,second:0,millisecond:0})
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public changeYear(event){
        this.filter.Year = event.srcElement.value;
        this.getPoints();
        
    }

    public AddPointsFormLoad() {
        $('#btnAddPointsForm').trigger('click');

        $(".date").datetimepicker({
            format: 'DD/MM/YYYY'
        });
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }
    public getPointType() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["PointType"] }).subscribe(
            data => {
                this.pointType = data["Parameter"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getUsers(IsActive: boolean) {
        this.showLoader = true;
        var userId = 0;
        if (this.userDetail.SiteUserId != 0) {
            userId = this.userDetail.SiteUserId;
        }
        this._httpService.ajaxPost('Users/GetUsers', {
            "IsActive": IsActive,
            "Team": this.userDetail.TeamID,
            "UserId": userId
        }).subscribe(
            data => {
                this.siteUserItems = data["Users"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
            );
    }

    public getPoints() {
        this.showLoader = true;
        this._httpService.ajaxPost('Review/GetPoints', { "ReviewerId": this.userDetail.SiteUserId, "Year": this.filter.Year }).subscribe(
            data => {
                this.points = data["Points"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public CancelAddPoints() {
        this.existsUserName = false;
        this.addPointsData = { addPointsUserId: "", addPointsTypeId: "" };
        this.newForm();
        $('#addPoints').modal('hide');
        this.isAdd = true;
    }

    public CancelEditPoints() {
        this.existsUserName = false;
        this.editPointsData = { editPointsUserId:"", editPointsTypeId: "" };
        this.newForm();
        $('#editPoints').modal('hide');
        this.isAdd = true;
    }

    public AddPoints(form: any) {
        
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsUserName = false;
            // this.points.forEach(element => {
            //     if (element.UserId == this.addPointsData.addPointsUserId) {
            //         this.existsUserName = true;
            //     }
            // });

            if (!this.existsUserName) {
                let objItem: any = {};
                objItem.PointID = 0;
                objItem.UserId = this.addPointsData.addPointsUserId;
                objItem.ReviewerId = this.userDetail.SiteUserId;
                objItem.Date = this.addPointsData.addPointsDate;
                objItem.PointType = this.addPointsData.addPointsTypeId;
                objItem.Point = this.addPointsData.addPointsValue;
                objItem.Comment = this.addPointsData.addPointsComment;
                this.addEditPoints(objItem);
                $('#addPoints').modal('hide');
                this.addPointsData = { addPointsUserId:"", addPointsTypeId: "" };
                this.newForm();
                this.isAdd = true;
            }
        }
    }

    public EditPoints(item: any) {

        $('#btnEditPointsForm').trigger('click');
        this.isAdd = false;
        this.EditPointsChange(item.PointID);

        $(".date").datetimepicker({
            format: 'DD/MM/YYYY'
        });
    }

    public EditPointsChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.points.filter((points) => points.PointID == itemId)[0]));
        this.editPointsData.editPointsId = objItem.PointID;
        this.editPointsData.editPointsUserId = objItem.UserId;
        this.editPointsData.editPointsDate = objItem.Date;
        this.editPointsData.editPointsTypeId = objItem.PointType;
        this.editPointsData.editPointsValue = objItem.Point;
        this.editPointsData.editPointsComment = objItem.Comment;
    }

    public UpdatePoints(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsUserName = false;
            // this.points.forEach(element => {
            //     if (element.PointID != this.editPointsData.editPointsId && element.UserId == this.editPointsData.editPointsUserId) {
            //         this.existsUserName = true;
            //     }
            // })

            if (!this.existsUserName) {
                let objItem: any = {};
                objItem.PointsID = this.editPointsData.editPointsId;
                objItem.UserId = this.editPointsData.editPointsUserId;
                objItem.ReviewerId = this.userDetail.SiteUserId;
                objItem.Date = this.editPointsData.editPointsDate;
                objItem.PointType = this.editPointsData.editPointsTypeId;
                objItem.Point = this.editPointsData.editPointsValue;
                objItem.Comment = this.editPointsData.editPointsComment;
                this.addEditPoints(objItem);
                $('#editPoints').modal('hide');
                this.editPointsData = { editPointsUserId:"", editPointsTypeId: "" };
                this.newForm();
                this.isAdd = true;
            }
        }
    }

    addEditPoints(objItem) {
        this.showLoader = true;
        this._httpService.ajaxPost('Review/AddUpdatePoints', objItem).subscribe(
            data => {
                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.getPoints();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Review/Point.component.ts
 **/